badRequest:
  EMAIL_ADDRESS_IN_USE: |
    That email address is already in use. Every user must have a unique email address.